import React, { useState } from 'react';

import useQuery from '../utils/use-query';

export default function () {
    const [ filters, setFilters, ] = useQuery(
        useState({}),
        'push',
    );

    function onSubmit (e) {
        e.preventDefault();

        const formData = new FormData(document.getElementById('af-detail'));

        const {
            'dow[]': removeDOW,
            'time[]': removeTime,
            ...filters
        } = Object.fromEntries(formData);

        const dow = Array.from(formData.getAll('dow[]'));
        const time = Array.from(formData.getAll('time[]'));

        return setFilters({
            ...filters,
            ...(dow.length && { dow: dow.join(',') }),
            ...(time.length && { time: time.join(',') })
        });
    }

    function onReset () {
        return setFilters({});
    }
    const urlParams = new URLSearchParams(window.location.search);
    const leagueid = urlParams.get('leagueid');
    let dow = urlParams.get('dow') || "";
    let time = urlParams.get('time')|| "";
    let season = urlParams.get('season')|| "";

    

    let timestr ="Time of Day";
    if (time === "m") {
        timestr = "Morning";
    } else if (time === "a") {
        timestr = "Afternoon";
    } else if (time === "e") {
        timestr = "Evening";
    }

    let seasonstr ="Season";
    if (season !== '') {
        seasonstr = season;
    }

    let theid = urlParams.get('facility')|| "";
    let facstr ="Location";
         if (theid === "19")     { facstr = "Agriplace"; } 
        else if (theid === "3") { facstr = "Cwench Centre - Etobicoke"; } 
        else if (theid === "12") { facstr = "Jemini"; }
        else if (theid === "18") { facstr = "Lake Barrington"; }
        else if (theid === "2") { facstr = "Langley"; }
        else if (theid === "16") { facstr = "Mississauga"; }
        else if (theid === "8") { facstr = "North Shore"; }
        else if (theid === "13") { facstr = "Oakville"; }
        else if (theid === "14") { facstr = "Oshawa"; }
        else if (theid === "17") { facstr = "Romeoville"; }
        else if (theid === "15") { facstr = "Scarborough"; }
        else if (theid === "1") { facstr = "Scotia Barn"; }
        else if (theid === "10") { facstr = "South Cariboo Rec Centre"; }
        else if (theid === "4") { facstr = "West Dundee"; }
        else if (theid === "11") { facstr = "Winnipeg"; }
        else if (theid === "5") { facstr = "York"; }
        else if (theid === "9") { facstr = "Armstrong"; }
        else if (theid === "21") { facstr = "Libertyville"; }

    dow=dow.split(',')
    time=time.split(',')
    season=season.split(',')
    let showage = false;
    let ageclass= "";
    let showlength = false;
    let lengthclass = "";
    if ( window.AGE['AGE'] == "24" ) { showage = true; ageclass = "age"; };
    if ( window.PROGRAM_TYPES['CAMP'] == "1" ) { showlength = true; lengthclass = "length"; };

    function showFacOnChange(e) {
        e.preventDefault();

        const theid = e.target.dataset.theid;

        var select = document.getElementById("facility");
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theid ){
                select.options[i].selected = true;
            }
        }
        let facstr ="Location";
        if (theid == "19")     { facstr = "Agriplace"; } 
        else if (theid == "3") { facstr = "Cwench Centre - Etobicoke"; } 
        else if (theid == "12") { facstr = "Jemini"; }
        else if (theid == "18") { facstr = "Lake Barrington"; }
        else if (theid == "2") { facstr = "Langley"; }
        else if (theid == "16") { facstr = "Mississauga"; }
        else if (theid == "8") { facstr = "North Shore"; }
        else if (theid == "13") { facstr = "Oakville"; }
        else if (theid == "14") { facstr = "Oshawa"; }
        else if (theid == "17") { facstr = "Romeoville"; }
        else if (theid == "15") { facstr = "Scarborough"; }
        else if (theid == "1") { facstr = "Scotia Barn"; }
        else if (theid == "10") { facstr = "South Cariboo Rec Centre"; }
        else if (theid == "4") { facstr = "West Dundee"; }
        else if (theid == "11") { facstr = "Winnipeg"; }
        else if (theid == "5") { facstr = "York"; }
        else if (theid == "9") { facstr = "Armstrong"; }
        else if (theid == "21") { facstr = "Libertyville"; }
        var factitle = document.getElementById('factitle');
        factitle.innerHTML = facstr;
        factitle.style.color = "#191818";
        onSubmit (e);
    }

    function showSeasonOnChange(e) {
        e.preventDefault();

        const theid = e.target.dataset.theid;

        var select = document.getElementById("season");
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theid ){
                select.options[i].selected = true;
            }
        }
        var seasontitle = document.getElementById('seasontitle');
        seasontitle.innerHTML = theid;
        seasontitle.style.color = "#191818";
        onSubmit(e);
    }

    function showDowOnChange(e){
        e.preventDefault();
        e.stopPropagation();

        const theid = e.target.dataset.id;
        const checkbox = document.getElementById(theid);
        checkbox.checked = !checkbox.checked

        onSubmit(e);
    }

    function showTodOnChange(e) {
        e.preventDefault();

        const theid = e.target.dataset.theid;

        var select = document.getElementById("time");
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theid ){
                select.options[i].selected = true;
            }
        }
        let timestr ="Time of Day";
        if (theid == "m") {
            timestr = "Morning";
        } else if (theid == "a") {
            timestr = "Afternoon";
        } else if (theid == "e") {
            timestr = "Evening";
        }
        var todtitle = document.getElementById('todtitle');
        todtitle.innerHTML = timestr;
        todtitle.style.color = "#191818";
        onSubmit(e);
    }

    function showAgeOnChange(e) {
        e.preventDefault();

        const theid = e.target.dataset.theid;
        var select = document.getElementById("age");
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theid ){
                select.options[i].selected = true;
            }
        }
        var todtitle = document.getElementById('agetitle');
        todtitle.innerHTML = theid;
        todtitle.style.color = "#191818";
        onSubmit(e);
    }

    function showLengthOnChange(e) {
        e.preventDefault();

        const theid = e.target.dataset.theid;
        var select = document.getElementById("length");
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theid ){
                select.options[i].selected = true;
            }
        }
        var lengthtitle = document.getElementById('lengthtitle');
        lengthtitle.innerHTML = theid;
        lengthtitle.style.color = "#191818";
        onSubmit(e)
    }

    return (
        <div className="activity-finder-filters">
            
            <form id="af-detail" onSubmit={onSubmit} onReset={onReset}>
            <input type="hidden" name="leagueid" value={leagueid}></input>
                <div id="filter_div" className="activity-details">
                    <div className={"container "+ageclass+" "+lengthclass}>
                        {/* <div className="form-group filt">
                            <a id="afilter" class="filter_results selected" href={'javascript:filter_expand();'}>Filter Results</a>
                        </div> */}
                        <div id="facility-div" className="form-group form-group-select form-group-third">
                            <select defaultValue={filters.facility || ''} id="facility" name="facility">
                                <option value="">Location</option>
                                    {Object.entries(window.FAC2['fac2'] || {}).map(([id, name]) =>
                                        <option value={id}>{name}</option>
                                    )}
                            </select>
                            <p id="factitle" className="s_title">{facstr}</p>
                            <div id="facdetails" className="details">
                                {Object.entries(window.FAC2['fac2'] || {}).map(([id, name]) =>
                                    <a onClick={showFacOnChange} data-theid={id}>{name}</a>
                                )}
                            </div>
                        </div>

                        <div id="date" className="form-group form-group-third form-group-date">
                            <p id="starttitle" onClick={onSubmit} className="s_title">Start Date</p>

                            <input
                                defaultValue={filters.start}
                                id="start"
                                name="start"
                                type="text"
                                placeholder="Start Date"
                                title="Start Date"
                            />
                        </div>
                        {/* <div className="form-group form-group-third form-group-date">
                            <label htmlFor="end">End Date</label>
                            <input
                                defaultValue={filters.end}
                                id="end"
                                min={filters.start}
                                name="end"
                                type="date"
                                placeholder="YYYY-MM-DD"
                            />
                        </div> */}

                        {/* <div className="form-group form-group-select form-group-third">
                            <label htmlFor="season">Seasons</label>
                            <select  id="season" name="season">
                                <option value="">All Seasons</option>
                                    {Object.entries(window.SEASONS || {}).map(([id, name]) =>{
                                        return (<option value={id} selected={ id===season[0]? true:false } >{name}</option>)
                                    })} 
                            </select>
                        </div>*/
                        <div id="season-div" className="form-group form-group-select form-group-third">
                        <select defaultValue={filters.time || ''} id="season" name="season">
                            <option value="">All Seasons</option>
                                {Object.entries(window.SEASONS || {}).map(([id, name]) =>{
                                    return (<option value={id} selected={ id===season[0]? true:false } >{name}</option>)
                                })} 
                        </select>
                        <p id="seasontitle" className="s_title">{seasonstr}</p>
                            <div id="seasondetails" className="details">
                                {Object.entries(window.SEASONS || {}).map(([id, name]) =>
                                    <a onClick={showSeasonOnChange} data-theid={id}>{name}</a>
                                )}
                            </div>
                        </div>
                        }

                        <div className="form-group form-group-third days-of-week">
                            <p id="dowtitle" className="label">Day of Week</p>
                            {Object.entries(window.DAYS_OF_WEEK).map(([id, name]) => [
                                <input id={`day-${id}`} name="dow[]" data-temp={dow} type="checkbox" checked={dow.includes(id)} value={id}/>,
                                <label onClick={showDowOnChange} data-id={`day-${id}`} htmlFor={`day-${id}`}>{name.charAt(0)}</label>
                            ])}
                        </div>
                        {/* <div className="form-group form-group-third time-of-day">
                            <p className="label">Time of Day</p>
                            {Object.entries(window.TIMES_OF_DAY).map(([id, name]) => [
                                <input id={`time-${id}`} name="time[]" type="checkbox" defaultChecked={time.includes(id)} value={id}/>,
                                <label class="tod" htmlFor={`time-${id}`}>{name}</label>
                            ])}
                        </div>  */}
                        <div id="tod-div" className="form-group form-group-select form-group-third">
                            <select defaultValue={filters.time || ''} id="time" name="time">
                                <option value="">Time of Day</option>
                                    {Object.entries(window.TIMES_OF_DAY || {}).map(([id, name]) =>
                                        <option value={id}>{name}</option>
                                    )}
                            </select> 
                            <p id="todtitle" className="s_title">{timestr}</p>
                            <div id="toddetails" className="details">
                                {Object.entries(window.TIMES_OF_DAY || {}).map(([id, name]) =>
                                    <a onClick={showTodOnChange} data-theid={id} href="">{name}</a>
                                )}
                            </div>
                        </div>

                        { showlength &&

                            <div id="length-div" className="form-group form-group-select form-group-third">
                                <select defaultValue={filters.length || ''} id="length" name="length">
                                    <option value="">Length</option>
                                    <option value="Full Day">Full Day</option>
                                    <option value="Half Day">Half Day</option>
                                </select> 
                                <p id="lengthtitle" className="s_title">{filters.length || 'Length'}</p>
                                <div id="lengthdetails" className="details">
                                    <a onClick={showLengthOnChange} data-theid="Full Day" >Full Day</a>
                                    <a onClick={showLengthOnChange} data-theid="Half Day" >Half Day</a>
                                </div>
                            </div>

                        }
                        { showage &&
                            <div id="age-div" className="form-group form-group-select form-group-third">
                                <select defaultValue={filters.age || ''} id="age" name="age">
                                    <option value="">Age</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                </select> 
                                <p id="agetitle" className="s_title">{filters.age || 'Age'}</p>
                                <div id="agedetails" className="details">
                                    <a onClick={showAgeOnChange} data-theid={3} >3</a>
                                    <a onClick={showAgeOnChange} data-theid={4} >4</a>
                                    <a onClick={showAgeOnChange} data-theid={5} >5</a>
                                    <a onClick={showAgeOnChange} data-theid={6} >6</a>
                                    <a onClick={showAgeOnChange} data-theid={7} >7</a>
                                    <a onClick={showAgeOnChange} data-theid={8} >8</a>
                                    <a onClick={showAgeOnChange} data-theid={9} >9</a>
                                    <a onClick={showAgeOnChange} data-theid={10} >10</a>
                                    <a onClick={showAgeOnChange} data-theid={11} >11</a>
                                    <a onClick={showAgeOnChange} data-theid={12} >12</a>
                                    <a onClick={showAgeOnChange} data-theid={13} >13</a>
                                    <a onClick={showAgeOnChange} data-theid={14} >14</a>
                                    <a onClick={showAgeOnChange} data-theid={15} >15</a>
                                    <a onClick={showAgeOnChange} data-theid={16} >16</a>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="container2">
                        <div className="form-group form-group-third form-group-submit">
                            <button
                                aria-label="Submit"
                                className="btn btn-slide"
                                type="submit"
                                value="Search"
                            >FILTER RESULTS</button>
                        </div>
                        <button
                            aria-label="Clear Filters"
                            className="strip-style"
                            type="reset"
                            value="Clear"
                            id="filter-clear-detail"
                        >
                            Clear Results
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
